import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

// Feature 011 — Admin landing page (FR-039). Two cards: User Management and
// Create User.
export function AdminPage() {
  usePageTitle('Admin — Hawkes Bridge');

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-ink mb-6">Admin</h1>

      <div className="grid gap-6 sm:grid-cols-2">
        <Link
          to="/admin/users"
          className="block p-6 bg-card rounded-lg shadow hover:shadow-md transition border border-line"
        >
          <h2 className="text-lg font-semibold text-ink mb-2">User Management</h2>
          <p className="text-sm text-ink-soft">
            Review every non-Admin user. Switch roles between Editor and Public User. Tick or
            untick feature checkboxes for editors.
          </p>
        </Link>

        <Link
          to="/admin/users/new"
          className="block p-6 bg-card rounded-lg shadow hover:shadow-md transition border border-line"
        >
          <h2 className="text-lg font-semibold text-ink mb-2">Create User</h2>
          <p className="text-sm text-ink-soft">
            Provision a new Editor or Public User account. Editors can be granted access to
            specific data-editing surfaces at creation time.
          </p>
        </Link>

        {/* Feature 015 — Editor Activity monitoring */}
        <Link
          to="/admin/editor-activity"
          className="block p-6 bg-card rounded-lg shadow hover:shadow-md transition border border-line"
        >
          <h2 className="text-lg font-semibold text-ink mb-2">Editor Activity</h2>
          <p className="text-sm text-ink-soft">
            Review each editor's recent login activity — login and logout times, time spent, and
            the pages they visited over their last 15 active days.
          </p>
        </Link>
      </div>
    </div>
  );
}
